import { render, staticRenderFns } from "./ViewRemark.vue?vue&type=template&id=4dc8cf22&scoped=true&"
import script from "./ViewRemark.vue?vue&type=script&lang=js&"
export * from "./ViewRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc8cf22",
  null
  
)

export default component.exports